export default __webpack_public_path__ + "static/media/logo.5636bbf1.png";